import { MutationTree } from 'vuex'
import { mutationType } from './mutation-types'
import UserState, {IUserList} from './states'
import _ from 'lodash'
import axios from 'axios'

const completePathFn = process.env.VUE_APP_BASEURL
const mutations: MutationTree<UserState> = {
  [mutationType.GET_LISTS](
    state: UserState,
    data: IUserList,
  ): void {
    state.list = data
  },
  [mutationType.GET_LIST_LEADER](
    state: UserState,
    data: IUserList,
  ): void {
    state.listLeader = data
  },
  [mutationType.GET_LIST_STAFF](
    state: UserState,
    data: IUserList,
  ): void {
    state.listStaff = data
  },
  [mutationType.GET_LIST_CAREGIVER](
    state: UserState,
    data: IUserList,
  ): void {
    state.listCaregiver = data
  },
}

export default mutations
